import { NumberTicker } from "components/magicui/number-ticker";
import { useReducedMotion } from "motion/react";
import type { CSSProperties, ReactNode } from "react";

interface KpiNumberProps {
	value: number;
	decimalPlaces?: number;
	prefix?: ReactNode;
	suffix?: ReactNode;
	className?: string;
	style?: CSSProperties;
}

export function KpiNumber({
	value,
	decimalPlaces = 0,
	prefix,
	suffix,
	className,
	style,
}: KpiNumberProps) {
	const reducedMotion = useReducedMotion();

	if (reducedMotion) {
		const formatted = new Intl.NumberFormat("en-US", {
			minimumFractionDigits: decimalPlaces,
			maximumFractionDigits: decimalPlaces,
		}).format(value);
		return (
			<span className={className} style={style}>
				{prefix}
				{formatted}
				{suffix}
			</span>
		);
	}

	return (
		<span className={className} style={style}>
			{prefix}
			<NumberTicker value={value} decimalPlaces={decimalPlaces} />
			{suffix}
		</span>
	);
}
